import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SubscriptionFlowService } from '../services/subscription-flow.service';

export const subscriptionSuccessGuard: CanActivateFn = (route, state) => {
  const flow = inject(SubscriptionFlowService);
  const router = inject(Router);

  const canActivate: boolean = flow.isFlowActive() && !flow.isPendingActivation() && !flow.isPendingVerification();

  return canActivate ? true : router.createUrlTree(['/subscription/upgrade']);
};
